import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlinedSwipeIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M11 12V4.5C11 4.10218 10.842 3.72064 10.5607 3.43934C10.2794 3.15804 9.89782 3 9.5 3C9.10218 3 8.72064 3.15804 8.43934 3.43934C8.15804 3.72064 8 4.10218 8 4.5V13L6.53 11.53C6.23554 11.2359 5.85125 11.0486 5.43816 10.9978C5.02507 10.9471 4.60688 11.0359 4.25 11.25C3.91495 11.4509 3.67148 11.7745 3.57138 12.1522C3.47128 12.5298 3.52245 12.9315 3.714 13.272C5.593 16.612 6.688 18.521 7 19L7.196 19.3C7.74252 20.1299 8.48658 20.811 9.36138 21.2823C10.2362 21.7535 11.2143 22.0002 12.208 22H12H14C15.5913 22 17.1174 21.3679 18.2426 20.2426C19.3679 19.1174 20 17.5913 20 16V11.5C20 11.1022 19.842 10.7206 19.5607 10.4393C19.2794 10.158 18.8978 10 18.5 10C18.1022 10 17.7206 10.158 17.4393 10.4393C17.158 10.7206 17 11.1022 17 11.5M11 11.5V9.5C11 9.10218 11.158 8.72064 11.4393 8.43934C11.7206 8.15804 12.1022 8 12.5 8C12.8978 8 13.2794 8.15804 13.5607 8.43934C13.842 8.72064 14 9.10218 14 9.5V12M14 10.5C14 10.1022 14.158 9.72064 14.4393 9.43934C14.7206 9.15804 15.1022 9 15.5 9C15.8978 9 16.2794 9.15804 16.5607 9.43934C16.842 9.72064 17 10.1022 17 10.5V12M2.54102 5.59399C3.30843 5.03296 4.13302 4.55463 5.00102 4.16699M14 3.45799C15.32 3.81199 16.558 4.35999 17.685 5.06999",
		stroke: "#30515B",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgOutlinedSwipeIcon);
const Memo = memo(ForwardRef);
export default Memo;
